import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { useFoundrSpaceAnalytics } from "./foundrspace_analytics";
import { generalInfo, partnerConfig } from "./foundrspace_partner_config";

const Theme = lazyWithRetry(() => import("./foundrspace_theme"));

const faqs = [
  {
    question: "Pasadena",
    answer: `Our conference rooms provide a space for individuals or groups to come together 
    and share ideas, discuss projects, or simply catch up. With a variety of seating options, 
    whiteboards, and a projector, our conference rooms are equipped to handle anything you throw at it.`,
  },
  {
    question: "Rancho",
    answer: `Our conference room holds 10-12 people, and comes equipped with an Apple TV, HDMI cord,
              a large glass whiteboard for notes & presentations,
              a conference Bluetooth speakerphone, and is video-conference ready. 
              Guests can also enjoy complimentary coffee, snacks, and refreshments with a reservation.`,
  },
];

export function OfferingFoundrSpaceMeetingRoom() {
  useFoundrSpaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
